// extracted by mini-css-extract-plugin
export default {"icon":"CampoutsButton__icon___SdlVz"};